import PropTypes from 'prop-types';
import React from 'react';

import styles from './RemoveButton.module.scss';

const RemoveButton = ({ id, onClick, classNames = [], disabled = false }) => (
  <button
    id={id}
    className={[styles.button, 'font-w-500', 'font-s-10', ...classNames].join(' ')}
    type="button"
    onClick={onClick}
    disabled={disabled}
  >
    Remove
  </button>
);

RemoveButton.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  classNames: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

export default RemoveButton;
